// extracted by mini-css-extract-plugin
module.exports = {"LogoPane":"style_LogoPane__aTXWD"};